import { CACHE_VERSION } from './cacheVersion';
import API_URL from './url';
import $ from './AjaxRequest';

// queryApprovalUser 结果缓存：仅依赖 userId 的全局权限快照，按 type 维度缓存（TTL 420s，与既有权限缓存口径一致）。
// 同 type 在途请求合并：冷启动首个调用发请求并挂起，同 key 后续调用入队，响应后统一分发；
// 失败时清空队列（AjaxRequest 自带失败告警，各调用方与原生失败表现一致），下次调用重新发起。
// 只负责取数，各调用方的副作用（setState / redux dispatch / 权限标识写入）在 doneResult 中自行处理。
const CACHE_TTL = 420 * 1000;
const memCache = new Map();
const pending = new Map();

const storageKey = type => `approvalUser_${CACHE_VERSION}_${type || 'ALL'}`;

const readStore = key => {
    try {
        return JSON.parse(sessionStorage.getItem(key) || 'null');
    } catch (e) {
        return null;
    }
};

const writeStore = (key, entry) => {
    try {
        sessionStorage.setItem(key, JSON.stringify(entry));
    } catch (e) {
        // 配额/隐私模式异常时退化为仅内存缓存
    }
};

const queryApprovalUserCached = (type, doneResult, errorResult) => {
    const key = storageKey(type);
    const hit = memCache.get(key) || readStore(key);
    if (hit && Date.now() - hit.ts < CACHE_TTL) {
        memCache.set(key, hit);
        doneResult(hit.data);
        return;
    }
    if (pending.has(key)) {
        pending.get(key).push({ done: doneResult, err: errorResult });
        return;
    }
    pending.set(key, [{ done: doneResult, err: errorResult }]);
    $.sendRequest({
        method: 'POST',
        url: API_URL.contract.queryApprovalUser,
        data: type ? { type } : {},
        dataType: 'json',
        doneResult: res => {
            const entry = { ts: Date.now(), data: res };
            memCache.set(key, entry);
            writeStore(key, entry);
            const cbs = pending.get(key) || [];
            pending.delete(key);
            cbs.forEach(cb => cb.done && cb.done(res));
        },
        // 业务错误（result.error）与网络级失败（.fail）均清空队列并透传给调用方
        //（如 loading 复位），下次调用重新发起
        errorResult: () => {
            const cbs = pending.get(key) || [];
            pending.delete(key);
            cbs.forEach(cb => cb.err && cb.err());
        },
        failResult: () => {
            const cbs = pending.get(key) || [];
            pending.delete(key);
            cbs.forEach(cb => cb.err && cb.err());
        },
    });
};

// Fetch.post 风格调用点的 promise 包装
const queryApprovalUserCachedAsync = type => new Promise((resolve, reject) => {
    queryApprovalUserCached(type, resolve, reject);
});

export { queryApprovalUserCached, queryApprovalUserCachedAsync };



// WEBPACK FOOTER //
// ./src/common/permissionCache.js